import { render, staticRenderFns } from "./addEducation.vue?vue&type=template&id=14c70ab9&scoped=true&"
import script from "./addEducation.vue?vue&type=script&lang=js&"
export * from "./addEducation.vue?vue&type=script&lang=js&"
import style0 from "./addEducation.vue?vue&type=style&index=0&id=14c70ab9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c70ab9",
  null
  
)

export default component.exports